import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getPracticePlantProtections, getPracticePlantProtectionsAdmin } from "services";

import { getEnvironment, injectNames } from "utils";

import { DEFAULT_CACHE_TIME, GET_PRACTICES_PLANT_PPROTECTION } from "consts";

import { PracticePlantProtection } from "models";

export const useGetPracticePlantProtections = () => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("practices", { useSuspense: false });
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? getPracticePlantProtectionsAdmin : getPracticePlantProtections;

  // Translate in select, not queryFn, so the cached data stays language-neutral and names follow language and namespace loads.
  const withTranslatedNames = useCallback((plantProtections: PracticePlantProtection[]) => injectNames(plantProtections, t, "plantProtections"), [t]);

  return useQuery({
    queryKey: [GET_PRACTICES_PLANT_PPROTECTION, isAdmin],
    queryFn: () => queryFn(),
    select: withTranslatedNames,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
